import { useEffect, useState } from 'react';

/**
 * Hook to subscribe to ActionCable channel for skip request approvals
 * @param {number} childId - ID of the child
 * @param {function} onApproval - Callback when skip request is approved
 */
export const useActionCable = (childId, onApproval) => {
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (!childId || typeof window.App === 'undefined' || !window.App.cable) {
      console.warn('ActionCable not available');
      return;
    }

    const channelName = `child_${childId}_skip_requests`;

    // Subscribe to channel
    const subscription = window.App.cable.subscriptions.create(
      { channel: 'SkipRequestChannel', child_id: childId },
      {
        connected() {
          console.log(`Connected to ${channelName}`);
          setIsConnected(true);
        },

        disconnected() {
          console.log(`Disconnected from ${channelName}`);
          setIsConnected(false);
        },

        received(data) {
          console.log('Received message:', data);

          if (data.type === 'skip_request_approved') {
            // Call the callback
            if (onApproval) {
              onApproval(data);
            }
          }
        }
      }
    );

    // Cleanup: unsubscribe on unmount
    return () => {
      subscription.unsubscribe();
    };
  }, [childId, onApproval]);

  return { isConnected };
};
